import type { IStorageOptions } from './types';
import { ClientStorage } from './ClientStorage';

export class LocalStorage extends ClientStorage {
  public constructor(options?: IStorageOptions) {
    super(localStorage, options);
  }
}
